import React from "react";

const PUBLIC_URL = process.env.PUBLIC_URL || "/SIPS";

// Add responsive styles for header navigation
const headerNavStyles = `
  .header-nav-btn {
    min-width: 44px !important;
    min-height: 36px !important;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    .header-nav-btn {
      padding: 0.375rem 0.75rem !important;
      font-size: 0.8rem !important;
    }
  }

  @media (max-width: 576px) {
    .header-nav-btn {
      padding: 0.375rem 0.5rem !important;
      font-size: 0.75rem !important;
      min-width: 40px !important;
    }
  }

  @media (max-width: 480px) {
    .header-nav-btn {
      padding: 0.25rem 0.375rem !important;
      min-width: 36px !important;
    }

    .partner-logos img {
      height: 1.8rem !important;
    }
  }

  @media (max-width: 360px) {
    .header-nav-btn {
      padding: 0.2rem 0.3rem !important;
      min-width: 32px !important;
      font-size: 0.7rem !important;
    }

    .partner-logos {
      display: none !important;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = headerNavStyles;
  document.head.appendChild(styleSheet);
}

const Header = () => {
  const handleManualClick = () => {
    // Open the PDF manual in a new tab
    window.open(`${PUBLIC_URL}/SIPS_manual.pdf`, '_blank');
  };

  return (
    <header style={headerStyle}>
      <div style={containerStyle}>
        <div style={leftColumnStyle}>
          <div style={logoTitleContainerStyle}>
            <img
              style={{ height: "2.5rem", marginRight: "10px" }}
              src={`${PUBLIC_URL}/logos/iwmi.png`}
              alt="IWMI logo"
            />
            <h4 className="site-title d-none d-sm-block" style={titleStyle}>
              Solar Irrigation Pump Sizing Tool
            </h4>
          </div>
        </div>

        {/* Navigation Buttons - Between logos and heading */}
        <div style={middleColumnStyle}>
          <div style={navButtonsStyle}>
            <button
              className="btn btn-outline btn-sm header-nav-btn"
              onClick={handleManualClick}
              style={{ gap: "0.25rem" }}
            >
              <span className="d-none d-sm-inline">📖 Manual</span>
            </button>
            <a
              href="mailto:iwmipk-wms@cgiar.org"
              className="btn btn-outline btn-sm header-nav-btn"
              style={{ textDecoration: "none", gap: "0.25rem" }}
            >
              <span className="d-inline d-sm-none">✉️</span>
              <span className="d-none d-sm-inline">Contact Us</span>
            </a>
          </div>
        </div>

        <div style={rightColumnStyle}>
          <div className="partner-logos">
            <ul
              style={{
                paddingLeft: 0,
                listStyle: "none",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                flexWrap: "wrap",
                margin: 0,
                alignItems: "center"
              }}
            >
              <li style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <img
                  style={{ height: "2.2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/pcrwr.png`}
                  alt="PCRWR logo"
                />
                <img
                  style={{ height: "2.2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/punjab.png`}
                  alt="Punjab logo"
                />
                <img
                  style={{ height: "2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/uk-aid.png`}
                  alt="UK Aid logo"
                />
                <img
                  style={{ height: "2.2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/cgiar.jpg`}
                  alt="CGIAR logo"
                />
                <img
                  style={{ height: "2.2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/sdc.png`}
                  alt="Swiss logo"
                />
                <img
                  style={{ height: "2.2rem", filter: "brightness(0.9)" }}
                  src={`${PUBLIC_URL}/logos/solarlogo.png`}
                  alt="Solar logo"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

const headerStyle = {
  width: "100%",
  background: "white",
  borderBottom: "1px solid #e0e0e0",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  fontFamily: "'Open Sans', sans-serif",
  position: "relative",
  zIndex: 1000
};

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "0 auto",
  padding: "0.75rem 1rem",
  width: "100%",
  gap: "0.5rem",
  flexWrap: "nowrap",
};

const leftColumnStyle = {
  display: "flex",
  alignItems: "center",
};

const middleColumnStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "0 1 auto",
  minWidth: "fit-content",
};

const rightColumnStyle = {
  display: "flex",
  alignItems: "center",
  overflowX: "auto",
};

const logoTitleContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const titleStyle = {
  color: "#2a537c",
  fontSize: "1.3rem",
  fontWeight: "600",
  margin: "0",
  textDecoration: "none",
  fontFamily: "'Open Sans', sans-serif"
};

const navButtonsStyle = {
  display: "flex",
  gap: "0.5rem",
  alignItems: "center",
  flexShrink: 0,
};

export default Header;
